import type { DetailedQuoteData } from "~/domains/orders/types/modelsV2";

export enum QuoteUploadState {
  INITIAL,
  UPLOADING,
  ERROR,
  UPLOAD_SUCCESS,
  LOADING_CART,
  SUCCESS,
}

export interface Msg {
  type: "warn" | "info" | "error";
  label: string;
}

export interface ProcessesedRows {
  lineItemId: number;
  customerNumber: string;
  endCustomerId: string;
  quoteNumber: string;
  position: number;
  quantity: number;
  date: Date;
  product: string;
  errorType?: "INVALID_ENTRY" | "INVALID_QUANTITY" | "MISSING_DATE" | null;
  hasDateBeenModified: boolean;
}

export interface PreviewQuotesData {
  processesedRows: ProcessesedRows[];
  quotesDetails: DetailedQuoteData;
  quoteNumber: string;
}

export interface QuoteSummary {
  quotesDetails: DetailedQuoteData;
  quoteNumber: string;
}

export interface PreviewData {
  invalidQuotes: string[];
  results: PreviewQuotesData[];
}
